export const sizes = {
  buttonGap: 7,
  buttonHeight: 36,
  buttonHeightLarge: 48,
  buttonHeightSmall: 30,
  cellContentHorizontalPadding: 10,
  cellContentVerticalPadding: 5,
  cellMinHeight: 55,
  cellMinHeightCompact: 42,
  /** Standard padding around dropdown card content. */
  dropdownCardContentPadding: 10,
  /** If a dropdown card is scrollable, reduce the padding where the scrollbar
   * is, because the scrollbar has its own padding as well. */
  dropdownCardContentPaddingReduced: 5,
  edgeCellsExtraHorizontalPadding: 5,
  iconButtonSize: 42,
  iconPaddedSize: 32,
  inputBorderWidth: 1,
  inputHeight: 36,
  inputHeightLarge: 64,
  inputHeightSmall: 30,
  minViewportWidth: 1000,
  navbarHeightMobile: 60,
  navbarWidthDesktop: 75,
  secondarySideBarWidth: 230,
  tableBorderRadius: 4,
  topbarHeight: 50,
} as const;
